<template>
  <div style="margin-top: 50px;">
    Đây là page ghi chú
  </div>
</template>

<script>
export default {};
</script>

<style lang="sass" scoped>
</style>